import { render, staticRenderFns } from "./addResourceStore.vue?vue&type=template&id=e2111a9c&scoped=true"
import script from "./addResourceStore.vue?vue&type=script&lang=js"
export * from "./addResourceStore.vue?vue&type=script&lang=js"
import style0 from "./addResourceStore.vue?vue&type=style&index=0&id=e2111a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2111a9c",
  null
  
)

export default component.exports